import React, { useState, useEffect } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Alert, Col, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { getMenuCounters } from '../../../utils/Api';
import Pagination from '../../../components/_Pagination';
import { loadTrainings } from '../../../actions/trainings';
import { getUrlParams, setUrlParams } from '../../../utils/helper';
import { isLocal, domain } from '../../../config';
import GridItem from './GridItem';
import ListItem from './ListItem';
import Loading from './Loading';

const path = isLocal ? '//localhost:3002/#' : `${domain}/company/#`;

const SwitchView = styled.div`
  text-align: right;

  i {
    padding: 10px;
    font-size: 34px;
    cursor: pointer;
  }
`;

const priorities = {
  1: 'A',
  2: 'B',
  3: 'C',
};

const statusesIntl = {
  1: 'lessons_lesson_status_completed',
  2: 'lessons_lesson_status_active',
  3: 'lessons_lesson_status_upcoming',
};

const limit = 12;

const mapStateToProps = ({
  user: { permissions, options },
  trainings: { list, total },
}) => ({
  permissions: permissions || [],
  allow_chat: options && options.allow_chat,
  hide_links_on_learning: options && options.hide_links_on_learning,
  all_in_one_tab: options && options.all_in_one_tab,
  list,
  total,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadItems: loadTrainings,
    },
    dispatch,
  );

const List = ({
  history,
  permissions,
  allow_chat,
  hide_links_on_learning,
  list,
  total,
  loadItems,
  match,
  courses,
  all_in_one_tab,
}) => {
  const getPageFromUrl = () => {
    const urlParams = getUrlParams(history.location.search);
    return urlParams.page ? +urlParams.page : 1;
  };

  const [isGridView, setIsGridView] = useState(true);
  const [page, setPage] = useState(getPageFromUrl());
  const reload = () => setPage(getPageFromUrl());

  useEffect(() => {
    window.addEventListener('hashchange', reload, false);

    return () => window.removeEventListener('hashchange', reload, false);
  }, []);

  useEffect(() => {
    loadItems({
      limit,
      ...(page === 1 ? {} : { offset: (page - 1) * limit }),
      ...(courses ? { courses } : {}),
    });
  }, [page]);

  useEffect(() => {
    if (list) {
      getMenuCounters().then((menuCounters) => {
        const user = JSON.parse(localStorage.getItem('user')) || {};
        user.counters = menuCounters;
        localStorage.setItem('user', JSON.stringify(user));
      });
    }
  }, [list]);

  if (!permissions.includes('MY_TRAININGS_LIST')) {
    return null;
  }

  if (!list) {
    return <Loading />;
  }

  // console.log("all_in_one_tab", all_in_one_tab);

  return (
    <div>
      {!hide_links_on_learning &&
      <div className="category_block">
        <ul>
          {allow_chat && (
            <li className="category">
              <Link to="/trainings/chats" target={all_in_one_tab ? "_self" : "_blank"}>
                <i className="icon_c icon_c_bg icon_chats" />
                <FormattedMessage id="routes_chats" />
              </Link>
            </li>
          )}
          <li className="category">
            <a href={`${path}/reports/users`} target={all_in_one_tab ? "_self" : "_blank"} rel="noreferrer">
              <i className="icon_c icon_c_bg icon_reports" />
              <FormattedMessage id="routes_reports" />
            </a>
          </li>
          <li className="category">
            <Link to="/trainings/notes" target={all_in_one_tab ? "_self" : "_blank"}>
              <i className="icon_c icon_c_bg icon_notes" />
              <FormattedMessage id="routes_notes" />
            </Link>
          </li>
          <li className="category">
            <Link to="/trainings/pictures" target={all_in_one_tab ? "_self" : "_blank"}>
              <i className="icon_c icon_c_bg icon_images" />
              <FormattedMessage id="routes_pictures" />
            </Link>
          </li>
          <li className="category">
            <Link to="/trainings/certificates" target={all_in_one_tab ? "_self" : "_blank"}>
              <i className="icon_c icon_c_bg icon_cert" />
              <FormattedMessage id="routes_certificates" />
            </Link>
          </li>
        </ul>
      </div>
      }
      <SwitchView>
        <i
          className={`icon_c_l icon_c_bg ${isGridView ? 'icon_list_view' : 'icon_tile_view'
            }`}
          onClick={() => setIsGridView(!isGridView)}
        />
      </SwitchView>
      {list.length ? (
        <div className={isGridView ? 'tiles' : ''}>
          {list.map(item =>
          (isGridView ? (
            <GridItem
              key={item.id}
              {...item}
              priorities={priorities}
              statusesIntl={statusesIntl}
              update={loadItems}
              page={page}
              limit={limit}
              all_in_one_tab={all_in_one_tab}
            />
          ) : (
            <ListItem
              key={item.id}
              {...item}
              priorities={priorities}
              statusesIntl={statusesIntl}
              update={loadItems}
              page={page}
              limit={limit}
              all_in_one_tab={all_in_one_tab}
            />
          )))}
        </div>
      ) : (
        <Alert color="secondary" style={{ width: '80%', margin: 'auto' }}>
          <FormattedMessage id="mytrainings_no_assigned" />
        </Alert>
      )}
      <Col>
        <FormGroup>
          <Pagination
            activePage={page}
            itemsPerPage={limit}
            totalItems={total}
            onChange={num =>
              setUrlParams({ ...(num === 1 ? {} : { page: num }) })
            }
          />
        </FormGroup>
      </Col>
      <div className="clear10" />
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(List));



// WEBPACK FOOTER //
// ./src/views/_MyTrainings/List/index.js